/* Koalla — Lightbox für Bilder im Artikeltext
   Jedes Bild im Blog-Inhalt (.article-template__content), das nicht schon
   verlinkt ist, öffnet sich per Klick als Overlay in voller Größe.
   Schließen: Klick, Escape, Wischen. Ohne Fremdbibliothek. */
(() => {
  const root = document.querySelector('.article-template__content');
  if (!root) return;
  // nur echte Bilder: nicht verlinkt, mit Quelle (der Editor lässt gelegentlich leere <img> zurück)
  const images = [...root.querySelectorAll('img')].filter((img) => !img.closest('a') && (img.getAttribute('src') || img.getAttribute('srcset')));
  if (!images.length) return;

  const overlay = document.createElement('div');
  overlay.className = 'k-lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', 'Bild in voller Größe');
  overlay.hidden = true;
  overlay.innerHTML =
    '<button type="button" class="k-lightbox__close" aria-label="Schließen">&times;</button>' +
    '<figure class="k-lightbox__figure"><img class="k-lightbox__img" alt=""><figcaption class="k-lightbox__caption"></figcaption></figure>';
  document.body.append(overlay);
  const big = overlay.querySelector('.k-lightbox__img');
  const caption = overlay.querySelector('.k-lightbox__caption');
  let opener = null;

  // Shopify hängt bei Bildern aus der Bildpipeline eine Breite an (…&width=600);
  // für das Overlay die große Fassung ohne Breitenbeschränkung laden.
  const fullSrc = (img) => (img.currentSrc || img.src).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');

  const close = () => {
    overlay.hidden = true;
    document.documentElement.classList.remove('k-lightbox-open');
    big.removeAttribute('src');
    if (opener) opener.focus({ preventScroll: true });
  };
  const open = (img) => {
    opener = img;
    big.src = fullSrc(img);
    big.alt = img.alt || '';
    caption.textContent = img.alt || img.title || '';
    caption.hidden = !caption.textContent;
    overlay.hidden = false;
    document.documentElement.classList.add('k-lightbox-open');
    overlay.querySelector('.k-lightbox__close').focus({ preventScroll: true });
  };

  images.forEach((img) => {
    img.classList.add('k-lightbox__thumb');
    img.setAttribute('tabindex', '0');
    img.setAttribute('role', 'button');
    img.setAttribute('aria-label', (img.alt ? img.alt + ' – ' : '') + 'Bild vergrößern');
    img.addEventListener('click', () => open(img));
    img.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(img); } });
  });

  overlay.addEventListener('click', close);
  document.addEventListener('keydown', (e) => { if (!overlay.hidden && e.key === 'Escape') close(); });
  let touchY = null;
  overlay.addEventListener('touchstart', (e) => { touchY = e.touches[0].clientY; }, { passive: true });
  overlay.addEventListener('touchend', (e) => {
    if (touchY !== null && Math.abs(e.changedTouches[0].clientY - touchY) > 60) close();
    touchY = null;
  }, { passive: true });
})();
